import React, { useContext } from 'react';
import { useSearchParams } from 'react-router-dom';
import SideBar from '../../../components/common/SideBar/SideBarNew';
import Header from '../../../components/common/Header/Header';
import TaskPlanner from '../../../components/TaskPlanner/TaskPlanner';
import { LoginContext } from 'helpers/LoginContext';

const MyTaskPlanner = () => {
  const { sideBarPadding } = useContext(LoginContext);
  const [searchParams] = useSearchParams();
  const taskUuid = searchParams.get('task');

  return (
    <div className='min-h-full'>
      <SideBar />
      <div
        className={`${
          sideBarPadding
            ? 'lg:pl-[4rem] duration-300'
            : 'lg:pl-64 duration-300'
        } flex flex-col`}
      >
        <main className='h-screen flex-1 bg-gray-50'>
          <Header
            title='My Tasks'
            desc='Organize and track your personal tasks'
          />
          <div className='w-full px-4 sm:px-6 lg:px-8 py-6'>
            <TaskPlanner initialTaskUuid={taskUuid} />
          </div>
        </main>
      </div>
    </div>
  );
};

export default MyTaskPlanner;
